
export default {
  name: 'ListingsForEnterprise',
}
